const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/LoginPage/FormContent/styles.ts';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

export const squashedSmallDevice = css`
    display: flex;
    flex-direction: column;
    align-items: start;
`;

export const squashedSmallDeviceGrid = css`
    display: flex;
    flex-wrap: wrap;
`;

export const addLeftMargin = css`
    margin-left: ${theme.spacing(24 / 8)};
`;
